import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/attribute-green.svg'


const _withScopeId = n => (_pushScopeId("data-v-7e4fd68a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-white rounded-4 shadow p-4 mb-5" }
const _hoisted_2 = { class: "fw-bold" }
const _hoisted_3 = {
  key: 0,
  class: "d-flex justify-content-center mb-5"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spinner-border" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "avatar d-flex justify-content-center flex-column align-items-center" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-2 ms-2" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_9 = { class: "fs-7" }
const _hoisted_10 = { class: "fw-bold" }
const _hoisted_11 = {
  key: 0,
  class: "ms-1"
}
const _hoisted_12 = {
  key: 1,
  class: "ms-1"
}
const _hoisted_13 = { class: "d-flex flex-wrap justify-content-center mb-4" }
const _hoisted_14 = { class: "edit-form py-5 px-2 my-4 rounded-4" }
const _hoisted_15 = { class: "border-bottom row mx-3 mx-md-5 px-0 pb-4 gx-3 mb-4 fs-7" }
const _hoisted_16 = { class: "w-max-content col-lg-2 col-form-label" }
const _hoisted_17 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_18 = { class: "row mx-0 px-0 col-lg-2 mt-2" }
const _hoisted_19 = { class: "form-check" }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = {
  class: "form-check-label cursor-pointer",
  for: "flexRadioDefault1"
}
const _hoisted_22 = { class: "row mx-0 px-0 col-lg-4 mt-2" }
const _hoisted_23 = { class: "form-check" }
const _hoisted_24 = ["disabled"]
const _hoisted_25 = {
  class: "form-check-label cursor-pointer",
  for: "flexRadioDefault2"
}
const _hoisted_26 = { class: "border-bottom row mx-3 mx-md-5 px-0 pb-4 gx-3 mb-4 fs-7" }
const _hoisted_27 = { class: "w-max-content col-lg-3 col-form-label" }
const _hoisted_28 = { class: "col-lg-9 d-flex flex-wrap" }
const _hoisted_29 = { class: "form-check" }
const _hoisted_30 = ["name", "id", "checked", "disabled", "onClick"]
const _hoisted_31 = ["for"]
const _hoisted_32 = { class: "d-flex justify-content-center" }
const _hoisted_33 = {
  class: "modal fade",
  id: "modalConfirmUpdate",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_34 = { class: "modal-dialog modal-lg" }
const _hoisted_35 = { class: "modal-content" }
const _hoisted_36 = { class: "modal-header" }
const _hoisted_37 = { class: "modal-title fw-bold text-center w-100" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1))
const _hoisted_39 = { class: "modal-body content p-0" }
const _hoisted_40 = { class: "row py-3 px-5" }
const _hoisted_41 = { class: "col-4" }
const _hoisted_42 = { class: "col-8" }
const _hoisted_43 = {
  key: 0,
  class: "fs-7 text-danger notice p-3"
}
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-bottom" }, null, -1))
const _hoisted_45 = { class: "row py-3 px-5" }
const _hoisted_46 = { class: "col-4" }
const _hoisted_47 = { class: "col-8 d-flex flex-wrap" }
const _hoisted_48 = { class: "modal-footer" }
const _hoisted_49 = { class: "row w-100 mx-0 px-0 d-flex justify-content-center flex-lg-row flex-column-reverse mb-4" }
const _hoisted_50 = { class: "col-lg-6 d-flex justify-content-lg-end justify-content-center" }
const _hoisted_51 = { class: "col-lg-6 d-flex justify-content-lg-start justify-content-center mb-4 mb-lg-0" }
const _hoisted_52 = {
  class: "modal fade",
  id: "modalSuccess",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_53 = { class: "modal-dialog" }
const _hoisted_54 = { class: "modal-content" }
const _hoisted_55 = { class: "modal-header" }
const _hoisted_56 = { class: "modal-title fw-bold text-center w-100" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1))
const _hoisted_58 = { class: "modal-body content" }
const _hoisted_59 = { class: "text-center fs-7" }
const _hoisted_60 = { class: "modal-footer" }

import { computed, onMounted, ref, watchEffect } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { Modal } from 'bootstrap'

import Button from '@/components/button/index.vue'
import Tabs, { Tab } from '@/components/tabs/index.vue'
import TabPanel from '@/components/tabs/panel/TabPanel.vue'
import ManagementInfo from './components/ManagementInfo.vue'
import BasicInformation from './components/BasicInformation.vue'
import Additional from './components/Additional.vue'
import Active from './components/Active.vue'
// import Modal from './components/Modal.vue'
import Breadcrumb from '@/components/breadcrumb/index.vue'

import { translate } from '@/languages/i18n'
import { ACCOUNT_STORE, COMMUNITY_ALUMNUS_STORE } from '@/store/constants'
import communityAlumnusServices from '@/services/community-alumnus.services'
import PortfolioModal from './components/PortfolioAlumni.vue'
import PointHistory from './components/PointHistory.vue'
import Status from '@/components/status/index.vue'
import Avatar from '@/components/avatar/index.vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const router = useRouter()

const store = useStore()

const dataDetail = computed(() => store.getters[COMMUNITY_ALUMNUS_STORE.GETTERS.GET_DETAIL_ALMNUS]?.detailAlmnus)
const loading = computed(() => store.getters[COMMUNITY_ALUMNUS_STORE.GETTERS.GET_DETAIL_ALMNUS]?.loading)

const listFlags = computed(() => store.getters[COMMUNITY_ALUMNUS_STORE.GETTERS.GET_LIST_MANAGING_FLAGS])
const showModal = computed(() => store.getters[ACCOUNT_STORE.GETTERS.PROFILE_DETAIL]?.showModal)

onMounted(() => {
  getListData()
  const modalBackdrop = document.getElementsByClassName('modal-backdrop')
  if (modalBackdrop) {
    document.body.style.removeProperty('overflow')
    document.body.style.removeProperty('padding-right')
    while (modalBackdrop.length > 0) {
      modalBackdrop[0].parentNode.removeChild(modalBackdrop[0])
    }
  }
})

const getListData = () => {
  store.dispatch(COMMUNITY_ALUMNUS_STORE.ACTIONS.SET_DETAIL_ALMNUS, { id: route.params?.id, idAlumni: route.params?.idAlumni, management_no: 'desc' })
  store.dispatch(COMMUNITY_ALUMNUS_STORE.ACTIONS.SET_LIST_MANAGING_FLAGS, route.params?.id)
}

const breadcrumb = [
  {
    content: translate('CC10home'),
    to: `/community/communities/${route.params?.id}/dashboard`,
    active: false,
  },
  {
    content: translate('OE30userManagement'),
    to: '',
    active: false,
  },
  {
    content: `${translate('OE10listUser')}（${translate('almunai')}）`,
    to: `/community/communities/${route.params?.id}/alumnus?management_no=desc`,
    active: false,
  },
  { content: translate('OE30titleAlumnai'), to: '', active: true },
]

const tabs: Array<Tab> = [
  {
    title: translate('basicInformation'),
    alias: 'basic-information',
  },
  {
    title: translate('OE30managementInformation'),
    alias: 'management-information',
  },
  {
    title: translate('OE30additionalItems'),
    alias: 'additional-items',
  },
  {
    title: translate('OE30activeInformation'),
    alias: 'active-information',
  },
]

const formData = ref<{ settings: boolean; managingFlags: number[] }>({
  settings: false,
  managingFlags: [],
})

const completeModal = ref()
const modalPorfolio = ref()
const modalPointHistory = ref()

const serverError = ref<boolean>(false)

const handleSubmit = async (): Promise<void> => {
  try {
    const response = await communityAlumnusServices.updateAlmunusDetailApi({
      id: route.params?.id,
      idAlumni: route.params?.idAlumni,
      data: { available: formData.value.settings, management_flag: formData.value.managingFlags },
    })

    if (response.status === 200) {
      serverError.value = false
      completeModal.value?.show()
      store.dispatch(COMMUNITY_ALUMNUS_STORE.ACTIONS.UPDATE_DETAIL_ALMUNUS, {
        status: formData.value.settings ? 'examinated' : 'available',
        available: formData.value.settings,
        management_flag: formData.value.managingFlags,
      })
      return
    }
    serverError.value = true
    completeModal.value?.show()
  } catch (error) {
    console.log(error)
    serverError.value = true
    completeModal.value?.show()
  }
}

const transitOE50 = (): void => {
  store.dispatch(COMMUNITY_ALUMNUS_STORE.ACTIONS.SET_LIST_RECORD_SELECTED, [dataDetail.value?.basic_information])
  router.push(`/community/communities/${route.params?.id}/alumnus/send_messages?user_type=2`)
}

const transitOE70 = (): void => {
  router.push(`/community/communities/${route.params?.id}/alumnus/${route.params?.idAlumni}/chat-list`)
}

const transitOE65 = (): void => {
  router.push(`/community/communities/${route.params?.id}/sent_messages_history?target_management_no=${route.params?.idAlumni}`)
}
const handleShowModal = async () => {
  await store.dispatch(ACCOUNT_STORE.ACTIONS.SET_PROFILE_DETAIL, {
    id: route.params.id,
    userID: route.params?.idAlumni,
    userType: 'alumni',
    isAdmin: true,
  })
  if (showModal.value) {
    await modalPorfolio.value?.show()
  }
}

const handleShowModalPointHistory = async () => {
  await store.dispatch(ACCOUNT_STORE.ACTIONS.SET_POINT_HISTORY, {
    id: route.params.id,
    userId: dataDetail.value?.alumni_user_id,
    params: {
      page: 1,
      page_of_number: 30,
    },
  })
  await modalPointHistory.value?.show()
}

watchEffect(() => {
  formData.value = {
    settings: dataDetail.value.available,
    managingFlags: dataDetail.value.management_flag || [],
  }
})

const handleManagingFlags = (id: any) => {
  if (formData.value.managingFlags.includes(id)) {
    formData.value.managingFlags = formData.value.managingFlags.filter((item: any) => Number(item) !== Number(id))
    return
  }
  formData.value.managingFlags.push(id)
}

onMounted(() => {
  completeModal.value = new Modal(document.getElementById('modalSuccess'))
  modalPorfolio.value = new Modal(document.getElementById('editProfileModal'))
  modalPointHistory.value = new Modal(document.getElementById('modalPointHistory'))
})

watchEffect(() => {
  if (!loading.value && dataDetail.value?.errorServer) {
    router.replace(`/community/communities/${route.params?.id}/alumnus`)
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Breadcrumb, { breadcrumb: breadcrumb }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", _hoisted_2, _toDisplayString(_unref(translate)('OE30name')), 1),
      (_unref(loading))
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
        : _createCommentVNode("", true),
      (!_unref(loading))
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", {
                class: _normalizeClass(['avatar-info rounded-full mt-3', _unref(dataDetail)?.status === 'leave' ? 'opacity-20' : ''])
              }, [
                _createVNode(Avatar, {
                  user_image_url: _unref(dataDetail)?.image_url,
                  alt: "",
                  "user-type": "alumni"
                }, null, 8, ["user_image_url"])
              ], 2),
              _hoisted_8,
              _createElementVNode("p", _hoisted_9, _toDisplayString(_unref(translate)('managementNo')) + "." + _toDisplayString(_unref(dataDetail)?.management_no), 1),
              _createElementVNode("p", _hoisted_10, [
                _createTextVNode(_toDisplayString(_unref(dataDetail)?.basic_information?.family_name + ' ' + _unref(dataDetail)?.basic_information?.given_name), 1),
                (_unref(dataDetail)?.status === 'leave')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_unref(translate)('SO10user30')), 1))
                  : _createCommentVNode("", true),
                (_unref(dataDetail)?.status === 'available')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_unref(translate)('OE12pause')), 1))
                  : _createCommentVNode("", true),
                _createTextVNode("（" + _toDisplayString(_unref(dataDetail)?.basic_information?.display_name) + "）", 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(Button, {
                title: _unref(translate)('OE30messageHistory'),
                type: 'secondary',
                "class-name": "me-lg-4 mb-4",
                disabled: _unref(dataDetail)?.status !== 'examinated',
                onClick: transitOE50
              }, null, 8, ["title", "disabled"]),
              _createVNode(Button, {
                title: _unref(translate)('messageHistory'),
                type: 'secondary',
                "class-name": "me-lg-4 mb-4",
                onClick: transitOE65
              }, null, 8, ["title"]),
              _createVNode(Button, {
                title: _unref(translate)('chatList'),
                type: 'secondary',
                "class-name": "me-lg-4 mb-4",
                onClick: transitOE70
              }, null, 8, ["title"]),
              _createVNode(Button, {
                title: _unref(translate)('profile'),
                type: 'secondary',
                "class-name": "me-lg-4 mb-4",
                onClick: handleShowModal
              }, null, 8, ["title"]),
              _createVNode(Button, {
                title: _unref(translate)('OE30pointHistory'),
                type: 'secondary',
                "class-name": "mb-4",
                onClick: handleShowModalPointHistory
              }, null, 8, ["title"])
            ]),
            _createElementVNode("form", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("label", _hoisted_16, _toDisplayString(_unref(translate)('OE30usageSettings')), 1),
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(Status)
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input cursor-pointer",
                      disabled: _unref(dataDetail)?.status === 'leave',
                      type: "radio",
                      name: "flexRadioDefault1",
                      id: "flexRadioDefault1",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.settings) = $event)),
                      value: true
                    }, null, 8, _hoisted_20), [
                      [_vModelRadio, formData.value.settings]
                    ]),
                    _createElementVNode("label", _hoisted_21, _toDisplayString(_unref(translate)('OE30available')), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input cursor-pointer",
                      disabled: _unref(dataDetail)?.status === 'leave',
                      type: "radio",
                      name: "flexRadioDefault2",
                      id: "flexRadioDefault2",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.settings) = $event)),
                      value: false
                    }, null, 8, _hoisted_24), [
                      [_vModelRadio, formData.value.settings]
                    ]),
                    _createElementVNode("label", _hoisted_25, _toDisplayString(_unref(translate)('OE10pause')), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("label", _hoisted_27, _toDisplayString(_unref(translate)('userFlag')), 1),
                _createElementVNode("div", _hoisted_28, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(listFlags), (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "col-6 col-md-3 mt-2",
                      key: index
                    }, [
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("input", {
                          class: "form-check-input cursor-pointer",
                          type: "checkbox",
                          name: `flag-alumni${item?.name + item?.id}`,
                          id: `flag-alumni${item?.name + item?.id}`,
                          checked: formData.value.managingFlags?.includes(Number(item?.id)),
                          disabled: _unref(dataDetail)?.status === 'leave',
                          onClick: () => handleManagingFlags(item?.id)
                        }, null, 8, _hoisted_30),
                        _createElementVNode("label", {
                          class: "form-check-label cursor-pointer text-break",
                          for: `flag-alumni${item?.name + item?.id}`
                        }, _toDisplayString(item?.name), 9, _hoisted_31)
                      ])
                    ]))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_32, [
                _createVNode(Button, {
                  title: _unref(translate)('update'),
                  type: 'secondary',
                  dataBsToggle: 'modal',
                  disabled: _unref(dataDetail)?.status === 'leave',
                  dataBsTarget: '#modalConfirmUpdate'
                }, null, 8, ["title", "disabled"])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (!_unref(loading))
      ? (_openBlock(), _createBlock(Tabs, {
          key: 0,
          tabs: tabs,
          "default-alias": 'word'
        }, {
          default: _withCtx(() => [
            _createVNode(TabPanel, {
              alias: 'basic-information',
              keyName: 1
            }, {
              default: _withCtx(() => [
                _createVNode(BasicInformation, {
                  data: { ..._unref(dataDetail)?.basic_information, status: _unref(dataDetail)?.status },
                  invitedCommunityManagement: _unref(dataDetail)?.invited_community_management
                }, null, 8, ["data", "invitedCommunityManagement"])
              ]),
              _: 1
            }),
            _createVNode(TabPanel, {
              alias: 'management-information',
              keyName: 2
            }, {
              default: _withCtx(() => [
                _createVNode(ManagementInfo, {
                  data: _unref(dataDetail)?.management_information
                }, null, 8, ["data"])
              ]),
              _: 1
            }),
            _createVNode(TabPanel, {
              alias: 'additional-items',
              keyName: 3
            }, {
              default: _withCtx(() => [
                _createVNode(Additional, {
                  data: _unref(dataDetail)?.obtained_information,
                  status: _unref(dataDetail)?.status,
                  onGetListData: getListData
                }, null, 8, ["data", "status"])
              ]),
              _: 1
            }),
            _createVNode(TabPanel, {
              alias: 'active-information',
              keyName: 2
            }, {
              default: _withCtx(() => [
                _createVNode(Active, {
                  data: _unref(dataDetail)?.active_information
                }, null, 8, ["data"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_33, [
      _createElementVNode("div", _hoisted_34, [
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("h5", _hoisted_37, _toDisplayString(_unref(translate)('OE30title')), 1),
            _hoisted_38
          ]),
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("div", _hoisted_41, _toDisplayString(_unref(translate)('OE30usageSettings')), 1),
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("div", null, _toDisplayString(_unref(translate)(formData.value.settings ? 'OE30available' : 'OE10pause')), 1),
                (!formData.value.settings)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_43, _toDisplayString(_unref(translate)('OE30notice')), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _hoisted_44,
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("div", _hoisted_46, _toDisplayString(_unref(translate)('userFlag')), 1),
              _createElementVNode("div", _hoisted_47, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(listFlags)?.filter((item) => formData.value.managingFlags.includes(item?.id)), (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "me-3",
                    key: index
                  }, _toDisplayString(item?.name), 1))
                }), 128))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_48, [
            _createElementVNode("div", _hoisted_49, [
              _createElementVNode("div", _hoisted_50, [
                _createVNode(Button, {
                  title: _unref(translate)('cancel'),
                  type: 'secondary',
                  "data-bs-dismiss": "modal"
                }, null, 8, ["title"])
              ]),
              _createElementVNode("div", _hoisted_51, [
                _createVNode(Button, {
                  title: _unref(translate)('update'),
                  type: 'secondary',
                  onClick: handleSubmit,
                  "data-bs-dismiss": "modal"
                }, null, 8, ["title"])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_52, [
      _createElementVNode("div", _hoisted_53, [
        _createElementVNode("div", _hoisted_54, [
          _createElementVNode("div", _hoisted_55, [
            _createElementVNode("h5", _hoisted_56, _toDisplayString(_unref(translate)('OE30title')), 1),
            _hoisted_57
          ]),
          _createElementVNode("div", _hoisted_58, [
            _createElementVNode("div", _hoisted_59, _toDisplayString(_unref(translate)(serverError.value ? 'CC41updateFailed' : 'updateComplete')), 1)
          ]),
          _createElementVNode("div", _hoisted_60, [
            _createVNode(Button, {
              title: _unref(translate)('close'),
              type: 'secondary',
              "data-bs-dismiss": "modal"
            }, null, 8, ["title"])
          ])
        ])
      ])
    ]),
    _createVNode(PortfolioModal),
    _createVNode(PointHistory)
  ], 64))
}
}

})